/**
 * Last segment of DataTableColumn `key` values for business reference ids (quote/order/job numbers).
 * Those columns skip locale thousands grouping in PaginatedDataTable.
 */
export const triaxReferenceNumberColumnKeySuffixes: Readonly<Record<string, boolean>> = {
    quoteNumber: true,
    orderNumber: true,
    jobNumber: true,
};
